var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "hoistingDetail_" + _vm.selfKey,
        "hoistingDetail new-multiselect",
      ],
    },
    [
      _c(
        "div",
        { staticClass: "hoistingDetail_operate" },
        [
          _vm.showOperate && !_vm.parentPermitEditable
            ? [
                !_vm.isEditing && _vm.showEditBtn
                  ? _c(
                      "button",
                      {
                        staticClass: "btn--darkblue",
                        on: { click: _vm.changeEditStatus },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("action.edit")) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isEditing
                  ? _c(
                      "button",
                      {
                        staticClass: "btn--darkblue",
                        on: { click: _vm.cancel },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("action.cancel")) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isEditing
                  ? _c(
                      "button",
                      {
                        staticClass: "btn--orange",
                        on: {
                          click: function ($event) {
                            return _vm.onSave()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("action.save")) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isEditing
                  ? _c(
                      "button",
                      {
                        staticClass: "btn--orange",
                        attrs: { disabled: _vm.isSubmitDisable },
                        on: { click: _vm.submit },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("action.submit")) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.showPrint
            ? _c(
                "button",
                {
                  staticClass: "btn--orange",
                  on: { click: _vm.printHoisting },
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("workPermit.print")) + "\n    "
                  ),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      !_vm.isEditing && _vm.isWaitingApprove
        ? [
            _c("i", { staticClass: "gray_font" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("workPermit.waitingApproveBy", [_vm.personIncharge])
                )
              ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.submitByInfo.who && _vm.submitByInfo.when
        ? _c("i", { staticClass: "gray_font" }, [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$t("submittedByOn", [
                    _vm.submitByInfo.who,
                    _vm.submitByInfo.when,
                  ])
                ) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "hoistingDetail_contractor" }, [
        _c("p", { staticClass: "bold" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("workPermit.contractorName")) + "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            _vm._s(
              (_vm.hoistingContractorInfo && _vm.hoistingContractorInfo.name) ||
                _vm.$t("emptyValue")
            )
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "table",
        { class: ["hoistingDetail_table", { isEditing: _vm.isEditing }] },
        [
          _c("tr", [
            _c("td", { staticClass: "hoistingDetail_building" }, [
              _c("p", { class: ["bold"] }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("workPermit.building")) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "hoistingDetail_floor" }, [
              _c("p", { class: ["bold", { "required-flag": _vm.isEditing }] }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("workPermit.floor")) +
                    "\n        "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", { staticClass: "hoistingDetail_building" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("isEmptyValue")(_vm.buildingFullName)) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "td",
              { staticClass: "hoistingDetail_floor" },
              [
                _vm.isEditing
                  ? _c("HKLSelect", {
                      staticClass:
                        "small-6 medium-6 large-6 columns hoisting-floor-select",
                      class: { "error-highlight": !_vm.validFloor },
                      attrs: {
                        value: _vm.floorVal || undefined,
                        options: _vm.floorHklOptions,
                        showSearch: true,
                        placeholder: "",
                      },
                      on: {
                        change: function (val) {
                          return _vm.updateFloor(val)
                        },
                      },
                    })
                  : _c("span", [
                      _vm._v(_vm._s(_vm.getFloor() || _vm.$t("emptyValue"))),
                    ]),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "hoistingDetail_workArea" },
        [
          _c("InputField", {
            attrs: {
              readonly: !_vm.isEditing,
              showColon: false,
              showFlag: _vm.isEditing,
              label: _vm.isEdit
                ? _vm.$t("workPermit.workAreaWithIn")
                : _vm.$t("workPermit.workArea"),
              value: _vm.hoistingData.workArea,
              required: _vm.isEditing,
              showEmptyDash: true,
            },
            on: {
              updateValue: function (val) {
                return _vm.updateField("workArea", val)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "hoistingDetail_description" },
        [
          _c("InputField", {
            attrs: {
              label: _vm.$t("workPermit.descriptionOfWork"),
              readonly: !_vm.isEditing,
              showColon: false,
              placeholder: _vm.$t("workPermit.hoistingDescriptionWorkHint"),
              showFlag: _vm.isEditing,
              value: _vm.hoistingData.description,
              required: _vm.isEditing,
              showEmptyDash: true,
            },
            on: {
              updateValue: function (val) {
                return _vm.updateField("description", val)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "hoistingDetail_duration" }, [
        _c("p", { class: ["bold", { "required-flag": _vm.isEditing }] }, [
          _vm._v("\n      " + _vm._s(_vm.durationTitleLabel) + "\n    "),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "hoistingDetail_timePicker" },
          [
            _vm.isEditing
              ? _c("DateTimeSelector", {
                  key: "duration-from-" + _vm.timestamp,
                  attrs: {
                    timeOptions: _vm.timeOptions,
                    date: _vm.hoistingData.startDate,
                    showClearBtn: true,
                    setMinTime: true,
                    disabledDates: _vm.disabledFromDates,
                    highlightClass: !_vm.validStartDate
                      ? "error-highlight"
                      : "",
                    required: _vm.isEditing,
                    dirtyCheck: true,
                  },
                  on: { updateDate: _vm.onHoistingStartDateChange },
                })
              : _c("span", [
                  _vm._v(
                    _vm._s(_vm.formatDate(_vm.hoistingData.startDate, true))
                  ),
                ]),
            _vm._v(" "),
            _vm.isEditing
              ? _c("span", { staticClass: "hoistingDetail_timePickerTo" }, [
                  _vm._v("\n        " + _vm._s(_vm.$t("dateTo")) + "\n      "),
                ])
              : _c("span", [_vm._v("-")]),
            _vm._v(" "),
            _vm.isEditing
              ? _c("DateTimeSelector", {
                  key:
                    "date-to-" +
                    _vm.timestamp +
                    "-" +
                    (_vm.hoistingData.startDate || "no-from"),
                  attrs: {
                    timeOptions: _vm.timeOptions,
                    date: _vm.hoistingData.endDate,
                    showClearBtn: true,
                    setMinTime: true,
                    required: _vm.isEditing,
                    disabled:
                      !_vm.isHoistingToSelectorEnabled ||
                      !_vm.isHoistingEndWindowSelectable,
                    highlightClass: !_vm.validEndDate ? "error-highlight" : "",
                    disabledDateTimes: _vm.disabledEndDateTimes,
                    dirtyCheck: true,
                  },
                  on: {
                    updateDate: function (val) {
                      return _vm.updateField("endDate", val)
                    },
                  },
                })
              : _c("span", [
                  _vm._v(
                    _vm._s(_vm.formatDate(_vm.hoistingData.endDate, true))
                  ),
                ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "hoistingDetail_isHotRequired" }, [
        _c("p", { class: ["bold", { "required-flag": _vm.isEditing }] }, [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("workPermit.isHotTitle")) + "\n    "
          ),
        ]),
        _vm._v(" "),
        _vm.isEditing
          ? _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.isHotWork,
                    expression: "isHotWork",
                  },
                ],
                attrs: {
                  id: "hoistingDetail_isHotRequired_yes_" + _vm.hoistingData.id,
                  type: "radio",
                },
                domProps: { value: true, checked: _vm._q(_vm.isHotWork, true) },
                on: {
                  click: _vm._addHotWork,
                  change: function ($event) {
                    _vm.isHotWork = true
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  attrs: {
                    for:
                      "hoistingDetail_isHotRequired_yes_" + _vm.hoistingData.id,
                  },
                },
                [_vm._v(_vm._s(_vm.$t("action.yes")))]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.isHotWork,
                    expression: "isHotWork",
                  },
                ],
                attrs: {
                  id: "hoistingDetail_isHotRequired_no_" + _vm.hoistingData.id,
                  type: "radio",
                },
                domProps: {
                  value: false,
                  checked: _vm._q(_vm.isHotWork, false),
                },
                on: {
                  click: _vm._delHotWork,
                  change: function ($event) {
                    _vm.isHotWork = false
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  attrs: {
                    for:
                      "hoistingDetail_isHotRequired_no_" + _vm.hoistingData.id,
                  },
                },
                [_vm._v(_vm._s(_vm.$t("action.no")))]
              ),
            ])
          : _c("div", [
              _c("label", [
                _vm._v(
                  _vm._s(
                    _vm.isHotWork ? _vm.$t("action.yes") : _vm.$t("action.no")
                  )
                ),
              ]),
            ]),
      ]),
      _vm._v(" "),
      _vm.isHotWork ? _c("hr") : _vm._e(),
      _vm._v(" "),
      _vm.isHotWork
        ? _c(
            "div",
            { staticClass: "hotWorkDetails" },
            [
              _c("p", { staticClass: "bold" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("workPermit.hotWorkDetails")) +
                    "\n    "
                ),
              ]),
              _vm._v(" "),
              _c("ShowNotice", {
                attrs: {
                  id: _vm.hoistingData.id,
                  title: _vm.$t("workPermit.noticeHotWork"),
                  noticeContent: _vm.NoticeHotWorkContent,
                  expand: _vm.expendHotWorkNotice,
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "hotWorkDetails_typeOfWork" },
                [
                  _c("InputField", {
                    attrs: {
                      label: _vm.$t("workPermit.typeOfHotWork"),
                      readonly: !_vm.isEditing,
                      showFlag: _vm.isEditing,
                      showEmptyDash: true,
                      showColon: false,
                      value: _vm.getHotWorkField("type"),
                      required: true,
                    },
                    on: {
                      updateValue: function (val) {
                        return _vm.updateHotWorkAttr("type", val)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "hotWorkDetails_briefdescription" },
                [
                  _c("InputField", {
                    attrs: {
                      label: _vm.$t("workPermit.briefDescriptionofWork"),
                      readonly: !_vm.isEditing,
                      showFlag: _vm.isEditing,
                      showEmptyDash: true,
                      showColon: false,
                      value: _vm.getHotWorkField("description"),
                      required: true,
                    },
                    on: {
                      updateValue: function (val) {
                        return _vm.updateHotWorkAttr("description", val)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "hotWorkDetails_equipmentused" },
                [
                  _c("InputField", {
                    attrs: {
                      label: _vm.$t("workPermit.equipmentUsed"),
                      readonly: !_vm.isEditing,
                      showFlag: _vm.isEditing,
                      showEmptyDash: true,
                      showColon: false,
                      value: _vm.getHotWorkField("equipment"),
                      required: true,
                    },
                    on: {
                      updateValue: function (val) {
                        return _vm.updateHotWorkAttr("equipment", val)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "hotWorkDetails_attachments" },
        [
          _c("p", { class: ["bold"] }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("workPermit.attachment")) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _vm.isEditing && _vm.canEditCurrentHoisting
            ? _c("HkldDropzone", { attrs: { sourceId: _vm.sourceId } })
            : _vm._e(),
          _vm._v(" "),
          _c("EditAttachments", {
            attrs: {
              sourceId: _vm.sourceId,
              canDelete: _vm.isEditing && _vm.canEditCurrentHoisting,
              canDownloadAll: false,
              canEdit: _vm.isEditing && _vm.canEditCurrentHoisting,
              getFilesList: _vm.getFilesList,
            },
          }),
          _vm._v(" "),
          !_vm.isEditing && !_vm.filesLength
            ? _c("div", [_vm._v("\n      --\n    ")])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        { ref: "tooManyHoistingModal", attrs: { showCloseBtn: false } },
        [
          _c("p", { staticClass: "tooManyHoistingModalMessage" }, [
            _vm._v("\n      " + _vm._s(_vm.hoistingTooManyMessage) + "\n    "),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "button" },
                on: { click: _vm.closeTooManyHoistingModal },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("action.close")) + "\n      "
                ),
              ]
            ),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }